// Libs
import { BrowserRouter } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import { RequestProvider } from "react-request-hook";
import React from "react";
import ReactDOM from "react-dom";
import { Request, Sentry } from "@collectivehealth/cog";

// Components
import App from "components/App";

// Styles
import "styles/main.css";
import "styles/themes";

// Providers
import EmergencyAddStatusProvider from "providers/emergencyAdd/EmergencyAddStatus";
import EmergencyAddProvider from "providers/emergencyAdd/EmergencyAdd";
import FeatureSwitchProvider from "providers/FeatureSwitch";
import FilterProvider from "providers/Filter";
import PageLoaderProvider from "providers/PageLoader";
import PageTitleProvider from "providers/PageTitle";
import SidebarDisplayStateProvider from "providers/sidebar/DisplayState";
import SidebarMenuItemsProvider from "providers/sidebar/MenuItems";
import SponsorAdminProvider from "providers/SponsorAdmin";
import ToasterProvider from "providers/Toaster/Toaster";
import UrlSponsorProvider from "providers/UrlSponsor";
import LaunchDarklyProvider from "providers/LaunchDarkly";

// Pages
import Posing from "pages/posing";

// Utils
import { keepalive } from "utils/session/session";
import { initializeAmplitude } from "utils/analytics";

import * as serviceWorker from "./serviceWorker";

// Configure Sentry as soon as possible so we can capture all errors
const runtimeConfig = window.runtimeConfig || {};
Sentry.install({
  global: true,
  dsn: runtimeConfig.sentryDsn,
  options: {
    release: runtimeConfig.version || "N/A"
  }
});

// Start keepalive timer
keepalive();

initializeAmplitude();

// Attach the app to the root DOM node.
ReactDOM.render(
  <RequestProvider value={Request._axios}>
    <BrowserRouter>
      <LastLocationProvider>
        <PageLoaderProvider>
          <Posing>
            <PageTitleProvider>
              <EmergencyAddProvider>
                <EmergencyAddStatusProvider>
                  <FeatureSwitchProvider>
                    <ToasterProvider>
                      <SidebarDisplayStateProvider>
                        <SidebarMenuItemsProvider>
                          <UrlSponsorProvider>
                            <SponsorAdminProvider>
                              <FilterProvider>
                                <LaunchDarklyProvider app={App} />
                              </FilterProvider>
                            </SponsorAdminProvider>
                          </UrlSponsorProvider>
                        </SidebarMenuItemsProvider>
                      </SidebarDisplayStateProvider>
                    </ToasterProvider>
                  </FeatureSwitchProvider>
                </EmergencyAddStatusProvider>
              </EmergencyAddProvider>
            </PageTitleProvider>
          </Posing>
        </PageLoaderProvider>
      </LastLocationProvider>
    </BrowserRouter>
  </RequestProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
